import { NavLink } from 'react-router-dom'

const tabs = [
  { to: '/dashboard', label: 'Home', icon: 'home' },
  { to: '/inventory', label: 'Stock', icon: 'box' },
  { to: '/transactions', label: 'Trades', icon: 'receipt' },
  { to: '/reports', label: 'Reports', icon: 'chart' },
  { to: '/settings/backup', label: 'Settings', icon: 'gear' },
] as const

const paths: Record<(typeof tabs)[number]['icon'], string> = {
  home: 'M3 10.5 12 3l9 7.5M5 9.5V21h5v-6h4v6h5V9.5',
  box: 'M21 8 12 3 3 8v8l9 5 9-5V8ZM3 8l9 5 9-5M12 13v8',
  receipt: 'M6 2h12v20l-3-2-3 2-3-2-3 2V2ZM9 7h6M9 11h6M9 15h4',
  chart: 'M4 20V10M10 20V4M16 20v-8M22 20H2',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8-3a8 8 0 0 0-.1-1.2l2-1.6-2-3.4-2.4 1a8 8 0 0 0-2-1.2L15 3H9l-.5 2.6a8 8 0 0 0-2 1.2l-2.4-1-2 3.4 2 1.6A8 8 0 0 0 4 12c0 .4 0 .8.1 1.2l-2 1.6 2 3.4 2.4-1a8 8 0 0 0 2 1.2L9 21h6l.5-2.6a8 8 0 0 0 2-1.2l2.4 1 2-3.4-2-1.6c.1-.4.1-.8.1-1.2Z',
}

function Icon({ name }: { name: (typeof tabs)[number]['icon'] }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-5 w-5"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  )
}

/** Bottom tab bar with real icons and large tap targets (plan section 4). */
export function TabBar() {
  return (
    <nav
      aria-label="Primary"
      className="sticky bottom-0 z-10 grid grid-cols-5 border-t border-slate-800 bg-slate-950/95 backdrop-blur"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            [
              'flex flex-col items-center justify-center gap-1 py-2 text-[11px] font-medium',
              isActive ? 'text-sky-400' : 'text-slate-500',
            ].join(' ')
          }
        >
          <Icon name={t.icon} />
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
